<template>
    <div class="h-screen bg-neo-500 w-screen flex items-center justify-center">
        <div class="hidden md:block">
            <img src="/img/logo/elements_logo_color_white.svg" width="250px" alt="white" class="pb-8 animate__animated animate__fadeIn animate__delay-2s">
            <div class="-mb-8 text-6xl md:text-headline text-black font-bold -space-y-32 tracking-tighter -mt-20">
                <animated-text-line class="text-white" direction="Y" offset="110%" :delay="500">Brand</animated-text-line>
                <animated-text-line style="letter-spacing: -0.027em;"  class="text-white py-4" direction="Y" offset="110%" :delay="600" >Book</animated-text-line>
            </div>
            <router-link to="brand" tag="button"
                         class="text-lg bg-neo-500 border border-neo-400 hover:bg-neo-700 text-white font-bold px-4 pt-1 pb-2 rounded
                         animate__animated animate__fadeIn animate__delay-2s">
                Start &rarr;
            </router-link>
        </div>

      <div class="md:hidden">
            <img src="/img/logo/elements_logo_color_white.svg" width="200px" alt="white" class="animate__animated animate__fadeIn">
            <div class="text-6xl md:text-headline text-black font-bold tracking-tighter">
                <span class="text-white">Brand </span>
                <span style="letter-spacing: -0.027em;"  class="text-white">Book</span>
            </div>
            <router-link to="brand" tag="button"
                         class="mt-4 text-lg bg-neo-500 border border-neo-400 hover:bg-neo-700 text-white font-bold px-4 pt-1 pb-2 rounded
                         animate__animated animate__fadeIn">
                Start &rarr;
            </router-link>
        </div>
    </div>
</template>

<script>

    import AnimatedTextLine from "../components/Animations/AnimatedTextLine";

    export default {
        name: 'Home',
        components: {AnimatedTextLine},
    }
</script>
